import { DefaultApi, InviteFriendRequest } from '@smartswap/client-api';
import { config } from '@/configuration';

const defaultApi = new DefaultApi(config);

export async function addFriendEmail({ email }: InviteFriendRequest) {
	return defaultApi.invitePost({ inviteFriendRequest: { email } });
}
